import { z } from "zod";

// Public client configuration contract (ADR-0035 §6, issue #382). The SPA reads
// this ONE small, client-safe projection of server state at load via
// `GET /client-config` — no login, no anon session, no PII. It exists so a
// visibility decision that must be made ON THE CLIENT before any interaction (the
// AR entry point, "never shown broken") can read a server-owned kill-switch
// (ADR-0031) without coupling that global flag to a per-job manifest or an admin
// surface.
//
// It is a CURATED projection, never the raw `feature_flags` table: only flags that
// are safe to expose publicly appear here (e.g. `payments_disabled` stays
// server-enforced and is NOT surfaced). Today it carries exactly one field; add a
// new client-safe boolean only when a real client-side gate needs it.
export const ClientConfig = z.object({
  // Whether the in-room AR preview entry point ("Zobacz w swoim pokoju") is enabled
  // (the `ar_preview_enabled` launch flag). The button renders only when this is
  // true AND the device is AR-capable (ADR-0035 §6/§7). Default-OFF server-side, so
  // an unreachable/failed read is treated as `false` by the client — fail-hidden.
  arPreviewEnabled: z.boolean(),
  // Whether the cart's "Dodaj Obraz 3D" affordance is offered (the `three_d_print_enabled`
  // launch flag). Gates the in-cart add-a-3D-print option the same way AR gates its button:
  // default-OFF server-side, treated as `false` on a failed read — so the option stays
  // hidden until the operator flips it on (admin Feature-flags tab, #241).
  threeDPrintEnabled: z.boolean(),
});
export type ClientConfig = z.infer<typeof ClientConfig>;
